import { render } from "./EmployeeReopenRequestsView.vue?vue&type=template&id=81ddcbe6&scoped=true"
import script from "./EmployeeReopenRequestsView.vue?vue&type=script&lang=js"
export * from "./EmployeeReopenRequestsView.vue?vue&type=script&lang=js"

import "./EmployeeReopenRequestsView.vue?vue&type=style&index=0&id=81ddcbe6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ddcbe6"]])

export default __exports__